import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { SeatsTab } from '../components/tabs/SeatsTab';
import { OrgChartTab } from '../components/tabs/OrgChartTab';

export function AccountabilityPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') ?? 'seats';

  const setTab = (next: string) => {
    searchParams.set('tab', next);
    setSearchParams(searchParams, { replace: true });
  };

  return (
    <div className="space-y-4">
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="seats">Seats</TabsTrigger>
          <TabsTrigger value="org-chart">Org Chart</TabsTrigger>
        </TabsList>
        <TabsContent value="seats" className="mt-4">
          <SeatsTab />
        </TabsContent>
        <TabsContent value="org-chart" className="mt-4">
          <OrgChartTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
